
/* injects from baggage-loader */

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { UICollapseElement, UIExpandElement } from '../../../actions/ui';
import PropTypes from 'prop-types';
import { createSelector } from "reselect";
import { browserHistory } from "react-router";

class Expandable extends Component {
    constructor (props) {
        super(props);
        this.state = {
            expandedIndex: 2
        };
        this.toggleElement = this.toggleElement.bind(this);
        this.toggleChildren = this.toggleChildren.bind(this);
        this.handleClick = this.handleClick.bind(this);
    }

    toggleElement (externalToggleHandler) {
        let expand;
        if (this.props.expanded === undefined) { //eslint-disable-line react /prop-types
            expand = !this.props.initiallyExpanded;
        } else {
            expand = !this.props.expanded; //eslint-disable-line react/prop-types
        }
        externalToggleHandler && externalToggleHandler(expand);
        expand ? this.props.dispatch(UIExpandElement(this.props.uiKey)) : this.props.dispatch(UICollapseElement(this.props.uiKey));
        if (this.props.onExpand && expand) {
            this.props.onExpand();
        }

        if (this.props.childrenKeys) {
            this.toggleChildren(!expand);
        }
    }

    componentDidMount () {
        this.props.openAnywhere && this.props.dispatch(UIExpandElement(this.props.uiKey));
    }

    UNSAFE_componentWillReceiveProps (nextProps) {
        nextProps.openAnywhere && !this.props.openAnywhere && this.props.dispatch(UIExpandElement(this.props.uiKey));
    }

    toggleChildren (expand) {
        this.props.childrenKeys.map(key => this.props.dispatch({
            true: UICollapseElement,
            false: UIExpandElement
        }[expand](key))); //eslint-disable-line react/prop-types
    }

    handleClick () {
        let { regionId } = this.props;
        return () => {
            if (this.props.setRegionCompetitionIds) {
                this.props.setRegionCompetitionIds(regionId);
            }
            this.toggleElement(this.props.handleToggleEvent);

        };
    }

    render () {
        let expanded = this.props.expanded; //eslint-disable-line react/prop-types
        expanded = expanded === undefined ? this.props.initiallyExpanded : expanded;
        return (
            <div className={(this.props.className || "") + " " + (expanded ? "active" : "")}
                onClick={this.props.casinoSearch ? null : this.handleClick()}>
                {this.props.children}
            </div>
        );
    }
}

Expandable.propTypes = {
    onExpand: PropTypes.func,
    className: PropTypes.string,
    initiallyExpanded: PropTypes.bool,
    openAnywhere: PropTypes.bool,
    childrenKeys: PropTypes.array,
    handleToggleEvent: PropTypes.func,
    expanded: PropTypes.bool,
    regionId: PropTypes.any,
    regionClick: PropTypes.bool,
    casinoSearch: PropTypes.bool,
    competitionIds: PropTypes.array,
    gameType: PropTypes.string,
    sportAlias: PropTypes.string,
    gamesCount: PropTypes.number,
    setRegionCompetitionIds: PropTypes.func
};

function mapStateToProps () {
    return createSelector(
        [
            (state, ownParams) => state.persistentUIState && state.persistentUIState.expanded && state.persistentUIState.expanded[ownParams.uiKey] && JSON.stringify(state.persistentUIState.expanded[ownParams.uiKey])
        ],
        expanded => ({expanded: expanded && JSON.parse(expanded)})
    );
}

export default connect(mapStateToProps)(Expandable);